import { render, staticRenderFns } from "./PrivateContentUserFree.vue?vue&type=template&id=4fc79c58&"
import script from "./PrivateContentUserFree.vue?vue&type=script&lang=js&"
export * from "./PrivateContentUserFree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports